import React, { useEffect, useState, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { GrainOverlay, ScrollProgress } from "@/components/pp/Shared";
import Preloader from "@/components/pp/Preloader";
import Navbar from "@/components/pp/Navbar";
import { WhatsAppFAB, MobileBottomBar } from "@/components/pp/Chrome";
import Hero from "@/components/pp/Hero";
import WhoWeAre from "@/components/pp/WhoWeAre";
import ServicesUniverse from "@/components/pp/ServicesUniverse";
import WhyPixelPapad from "@/components/pp/WhyPixelPapad";
import FeaturedWork from "@/components/pp/FeaturedWork";
import Process from "@/components/pp/Process";
import Pricing from "@/components/pp/Pricing";
import Industries from "@/components/pp/Industries";
import Team from "@/components/pp/Team";
import Collaborations from "@/components/pp/Collaborations";
import Testimonials from "@/components/pp/Testimonials";
import FAQ from "@/components/pp/FAQ";
import AIPlanner from "@/components/pp/AIPlanner";
import FinalCTA from "@/components/pp/FinalCTA";
import Contact from "@/components/pp/Contact";
import Footer from "@/components/pp/Footer";

function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem("pp_cookie_ok")) setShow(true); }, []);
  if (!show) return null;
  return (
    <div className="fixed bottom-20 md:bottom-6 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[76] pp-glass rounded-xl p-5" data-testid="cookie-consent">
      <p className="text-sm text-slate-300">We use cookies to improve your experience and measure performance. By continuing, you agree to our use of cookies.</p>
      <div className="mt-3 flex gap-3">
        <button onClick={() => { localStorage.setItem("pp_cookie_ok", "1"); setShow(false); }} data-testid="cookie-accept"
          className="bg-[#f59e0b] text-black text-xs font-semibold uppercase tracking-widest px-4 py-2">Accept</button>
        <button onClick={() => setShow(false)} className="text-xs text-slate-400 uppercase tracking-widest px-2">Dismiss</button>
      </div>
    </div>
  );
}

export default function App() {
  const [loaded, setLoaded] = useState(() => sessionStorage.getItem("pp_loaded") === "1");
  const lenisRef = useRef(null);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, wheelMultiplier: 1, touchMultiplier: 1.5 });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const onDone = () => { sessionStorage.setItem("pp_loaded", "1"); setLoaded(true); };

  return (
    <div className="App relative bg-[#030305] text-white min-h-screen">
      {!loaded && <Preloader onDone={onDone} />}
      <GrainOverlay />
      <ScrollProgress />
      <Navbar />

      <main>
        <Hero />
        <WhoWeAre />
        <ServicesUniverse />
        <WhyPixelPapad />
        <FeaturedWork />
        <Process />
        <Pricing />
        <Industries />
        <Team />
        <Collaborations />
        <Testimonials />
        <FAQ />
        <AIPlanner />
        <FinalCTA />
        <Contact />
      </main>

      <Footer />
      <WhatsAppFAB />
      <MobileBottomBar />
      <CookieConsent />
      <Toaster position="top-center" richColors />
    </div>
  );
}
